
// import React, { useState, useEffect } from "react";
// import { db, auth } from "../firebase/firebase";
// import {
//   collection,
//   onSnapshot,
//   deleteDoc,
//   doc,
//   updateDoc
// } from "firebase/firestore";
// import { onAuthStateChanged, signOut } from "firebase/auth";
// import { useNavigate } from "react-router-dom";

// export default function About() {
//   const navigate = useNavigate();

//   const [appointments, setAppointments] = useState([]);
//   const [editingId, setEditingId] = useState(null);
//   const [editData, setEditData] = useState({});
//   const [loading, setLoading] = useState(true);

//   // 🔐 AUTH GUARD (ADMIN EMAIL ONLY)
//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       if (!user || user.email !== "stefanstojilkovicspqr@gmail.com") {
//         navigate("/admin-login");
//       } else {
//         setLoading(false);
//       }
//     });

//     return () => unsubscribe();
//   }, [navigate]);

//   // 📡 REALTIME LISTENER (ONLY AFTER AUTH)
//   useEffect(() => {
//     if (loading) return;

//     const collectionRef = collection(db, "appointments");
//     const unsubscribe = onSnapshot(collectionRef, (snapshot) => {
//       const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
//       setAppointments(data);
//     });

//     return () => unsubscribe();
//   }, [loading]);

//   // 🗑 DELETE
//   const deleteAppointment = async (id) => {
//     if (!window.confirm("Delete this appointment?")) return;
//     try {
//       await deleteDoc(doc(db, "appointments", id));
//     } catch (err) {
//       console.error(err);
//       alert("Delete failed");
//     }
//   };

//   // ✏ START EDIT
//   const startEdit = (appt) => {
//     setEditingId(appt.id);
//     setEditData({ ...appt });
//   };

//   // 🔄 CHANGE INPUT
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setEditData((prev) => ({ ...prev, [name]: value }));
//   };

//   // 💾 SAVE EDIT
//   const saveEdit = async (id) => {
//     try {
//       const { name, phone, haircut, date, time } = editData;
//       await updateDoc(doc(db, "appointments", id), { name, phone, haircut, date, time });
//       setEditingId(null);
//     } catch (err) {
//       console.error(err);
//       alert("Update failed");
//     }
//   };

//   // 🚪 LOGOUT
//   const handleLogout = async () => {
//     try {
//       await signOut(auth);
//       navigate("/admin-login");
//     } catch (err) {
//       console.error(err);
//       alert("Logout failed");
//     }
//   };

//   if (loading) return <div className="text-center py-5">Loading...</div>;

//   return (
//     <div className="container py-5">
//       <div className="d-flex justify-content-between align-items-center mb-4">
//         <h2>Salon Dashboard</h2>
//         <button className="btn btn-danger" onClick={handleLogout}>Logout</button>
//       </div>

//       <div className="table-responsive">
//         <table className="table table-striped table-bordered">
//           <thead className="table-dark">
//             <tr>
//               <th>Name</th>
//               <th>Phone</th>
//               <th>Service</th>
//               <th>Date</th>
//               <th>Time</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {appointments.sort((a, b) => new Date(a.date + ' ' + a.time) - new Date(b.date + ' ' + b.time)).map((appt) => (
//               <tr key={appt.id}>
//                 {editingId === appt.id ? (
//                   <>
//                     {['name', 'phone', 'haircut', 'date', 'time'].map((field) => (
//                       <td key={field}>
//                         <input
//                           name={field}
//                           type={field === 'date' ? 'date' : 'text'}
//                           value={editData[field] || ''}
//                           onChange={handleChange}
//                           className="form-control"
//                         />
//                       </td>
//                     ))}
//                     <td>
//                       <button className="btn btn-success btn-sm me-2" onClick={() => saveEdit(appt.id)}>Save</button>
//                       <button className="btn btn-secondary btn-sm" onClick={() => setEditingId(null)}>Cancel</button>
//                     </td>
//                   </>
//                 ) : (
//                   <>
//                     <td>{appt.name}</td>
//                     <td>{appt.phone}</td>
//                     <td>{appt.haircut}</td>
//                     <td>{appt.date}</td>
//                     <td>{appt.time}</td>
//                     <td>
//                       <button className="btn btn-warning btn-sm me-2" onClick={() => startEdit(appt)}>Edit</button>
//                       <button className="btn btn-danger btn-sm" onClick={() => deleteAppointment(appt.id)}>Delete</button>
//                     </td>
//                   </>
//                 )}
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }








// import React, { useState, useEffect } from "react";
// import { db, auth } from "../firebase/firebase";
// import {
//   collection,
//   onSnapshot,
//   deleteDoc,
//   doc,
//   updateDoc
// } from "firebase/firestore";
// import { onAuthStateChanged, signOut } from "firebase/auth";
// import { useNavigate } from "react-router-dom";

// export default function About() {
//   const navigate = useNavigate();

//   const [appointments, setAppointments] = useState([]);
//   const [editingId, setEditingId] = useState(null);
//   const [editData, setEditData] = useState({});
//   const [loading, setLoading] = useState(true);

//   // 🔐 AUTH GUARD
//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       if (!user || user.email !== "stefanstojilkovicspqr@gmail.com") {
//         navigate("/admin-login");
//       } else {
//         setLoading(false);
//       }
//     });

//     return () => unsubscribe();
//   }, [navigate]);

//   // 📡 REALTIME
//   useEffect(() => {
//     if (loading) return;

//     const collectionRef = collection(db, "appointments");
//     const unsubscribe = onSnapshot(collectionRef, (snapshot) => {
//       const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
//       setAppointments(data);
//     });

//     return () => unsubscribe();
//   }, [loading]);

//   // 🗑 DELETE
//   const deleteAppointment = async (id) => {
//     if (!window.confirm("Delete this appointment?")) return;
//     try {
//       await deleteDoc(doc(db, "appointments", id));
//     } catch (err) {
//       console.error(err);
//       alert("Delete failed");
//     }
//   };

//   // ✏ EDIT
//   const startEdit = (appt) => {
//     setEditingId(appt.id);
//     setEditData({ ...appt });
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setEditData((prev) => ({ ...prev, [name]: value }));
//   };

//   const saveEdit = async (id) => {
//     try {
//       const { name, phone, haircut, date, time } = editData;
//       await updateDoc(doc(db, "appointments", id), {
//         name,
//         phone,
//         haircut,
//         date,
//         time
//       });
//       setEditingId(null);
//     } catch (err) {
//       console.error(err);
//       alert("Update failed");
//     }
//   };

//   // 🚪 LOGOUT
//   const handleLogout = async () => {
//     try {
//       await signOut(auth);
//       navigate("/admin-login");
//     } catch (err) {
//       console.error(err);
//       alert("Logout failed");
//     }
//   };

//   // 📅 GROUP + SORT
//   const groupedAppointments = appointments
//     .sort(
//       (a, b) =>
//         new Date(a.date + " " + a.time) -
//         new Date(b.date + " " + b.time)
//     )
//     .reduce((acc, appt) => {
//       if (!acc[appt.date]) acc[appt.date] = [];
//       acc[appt.date].push(appt);
//       return acc;
//     }, {});

//   // 🕒 NEXT APPOINTMENT
//   const now = new Date();
//   let nextAppt = null;

//   appointments.forEach((appt) => {
//     const apptDate = new Date(appt.date + " " + appt.time);
//     if (apptDate > now) {
//       if (
//         !nextAppt ||
//         apptDate < new Date(nextAppt.date + " " + nextAppt.time)
//       ) {
//         nextAppt = appt;
//       }
//     }
//   });

//   if (loading) return <div className="text-center py-5">Loading...</div>;

//   return (
//     <div className="container py-5">
//       <div className="d-flex justify-content-between align-items-center mb-4">
//         <h2>Salon Dashboard</h2>
//         <button className="btn btn-danger" onClick={handleLogout}>
//           Logout
//         </button>
//       </div>

//       {Object.keys(groupedAppointments).map((date) => (
//         <div key={date} className="mb-5">
//           {/* 📅 DATE */}
//           <h4 className="mb-3">
//             {new Date(date).toLocaleDateString()}
//           </h4>

//           <div className="row">
//             {groupedAppointments[date].map((appt) => {
//               const isNext = nextAppt && nextAppt.id === appt.id;

//               return (
//                 <div key={appt.id} className="col-md-4 mb-3">
//                   <div
//                     className={`card shadow-sm ${
//                       isNext ? "border-primary" : ""
//                     }`}
//                     style={{ borderWidth: isNext ? "2px" : "1px" }}
//                   >
//                     <div className="card-body">

//                       {editingId === appt.id ? (
//                         <>
//                           {["name", "phone", "haircut", "date", "time"].map(
//                             (field) => (
//                               <input
//                                 key={field}
//                                 name={field}
//                                 type={field === "date" ? "date" : "text"}
//                                 value={editData[field] || ""}
//                                 onChange={handleChange}
//                                 className="form-control mb-2"
//                               />
//                             )
//                           )}

//                           <button
//                             className="btn btn-success btn-sm me-2"
//                             onClick={() => saveEdit(appt.id)}
//                           >
//                             Save
//                           </button>
//                           <button
//                             className="btn btn-secondary btn-sm"
//                             onClick={() => setEditingId(null)}
//                           >
//                             Cancel
//                           </button>
//                         </>
//                       ) : (
//                         <>
//                           <h5 className="card-title">{appt.time}</h5>
//                           <p className="mb-1">
//                             <strong>{appt.name}</strong>
//                           </p>
//                           <p className="mb-1">{appt.haircut}</p>
//                           <p className="mb-2 text-muted">
//                             {appt.phone}
//                           </p>

//                           <button
//                             className="btn btn-warning btn-sm me-2"
//                             onClick={() => startEdit(appt)}
//                           >
//                             Edit
//                           </button>
//                           <button
//                             className="btn btn-danger btn-sm"
//                             onClick={() =>
//                               deleteAppointment(appt.id)
//                             }
//                           >
//                             Delete
//                           </button>

//                           {isNext && (
//                             <div className="mt-2 text-primary fw-bold">
//                               Next Appointment
//                             </div>
//                           )}
//                         </>
//                       )}

//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// }





// import React, { useState, useEffect } from "react";
// import { db, auth } from "../firebase/firebase";
// import {
//   collection,
//   onSnapshot,
//   deleteDoc,
//   doc,
//   updateDoc
// } from "firebase/firestore";
// import { onAuthStateChanged, signOut } from "firebase/auth";
// import { useNavigate } from "react-router-dom";

// export default function About() {
//   const navigate = useNavigate();

//   const [appointments, setAppointments] = useState([]);
//   const [editingId, setEditingId] = useState(null);
//   const [editData, setEditData] = useState({});
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       if (!user || user.email !== "stefanstojilkovicspqr@gmail.com") {
//         navigate("/admin-login");
//       } else {
//         setLoading(false);
//       }
//     });

//     return () => unsubscribe();
//   }, [navigate]);

//   useEffect(() => {
//     if (loading) return;

//     const collectionRef = collection(db, "appointments");
//     const unsubscribe = onSnapshot(collectionRef, (snapshot) => {
//       const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
//       setAppointments(data);
//     });

//     return () => unsubscribe();
//   }, [loading]);

//   const deleteAppointment = async (id) => {
//     if (!window.confirm("Delete this appointment?")) return;
//     try {
//       await deleteDoc(doc(db, "appointments", id));
//     } catch (err) {
//       console.error(err);
//       alert("Delete failed");
//     }
//   };

//   const startEdit = (appt) => {
//     setEditingId(appt.id);
//     setEditData({ ...appt });
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setEditData((prev) => ({ ...prev, [name]: value }));
//   };

//   const saveEdit = async (id) => {
//     try {
//       const { name, phone, haircut, date, time } = editData;
//       await updateDoc(doc(db, "appointments", id), {
//         name,
//         phone,
//         haircut,
//         date,
//         time
//       });
//       setEditingId(null);
//     } catch (err) {
//       console.error(err);
//       alert("Update failed");
//     }
//   };

//   const handleLogout = async () => {
//     try {
//       await signOut(auth);
//       navigate("/admin-login");
//     } catch (err) {
//       console.error(err);
//       alert("Logout failed");
//     }
//   };

//   const groupedAppointments = appointments
//     .sort(
//       (a, b) =>
//         new Date(a.date + " " + a.time) -
//         new Date(b.date + " " + b.time)
//     )
//     .reduce((acc, appt) => {
//       if (!acc[appt.date]) acc[appt.date] = [];
//       acc[appt.date].push(appt);
//       return acc;
//     }, {});

//   const now = new Date();
//   let nextAppt = null;

//   appointments.forEach((appt) => {
//     const apptDate = new Date(appt.date + " " + appt.time);
//     if (apptDate > now) {
//       if (
//         !nextAppt ||
//         apptDate < new Date(nextAppt.date + " " + nextAppt.time)
//       ) {
//         nextAppt = appt;
//       }
//     }
//   });

//   if (loading) return <div className="text-center py-5">Loading...</div>;

//   return (
//     <div className="container py-5 admin-dashboard">
//       <div className="d-flex justify-content-between align-items-center mb-4">
//         <h2>Salon Dashboard</h2>
//         <button className="btn btn-danger" onClick={handleLogout}>
//           Logout
//         </button>
//       </div>

//       {Object.keys(groupedAppointments).map((date) => (
//         <div key={date} className="mb-5">
//           <h4 className="mb-3">
//             {new Date(date).toLocaleDateString()}
//           </h4>

//           <div className="row">
//             {groupedAppointments[date].map((appt) => {
//               const isNext = nextAppt && nextAppt.id === appt.id;

//               return (
//                 <div key={appt.id} className="col-md-4 mb-3">
//                   <div
//                     className={`card shadow-sm ${
//                       isNext ? "border-primary" : ""
//                     }`}
//                     style={{ borderWidth: isNext ? "2px" : "1px" }}
//                   >
//                     <div className="card-body">

//                       {editingId === appt.id ? (
//                         <>
//                           {["name", "phone", "haircut", "date", "time"].map(
//                             (field) => (
//                               <input
//                                 key={field}
//                                 name={field}
//                                 type={field === "date" ? "date" : "text"}
//                                 value={editData[field] || ""}
//                                 onChange={handleChange}
//                                 className="form-control mb-2"
//                               />
//                             )
//                           )}

//                           <button
//                             className="btn btn-success btn-sm me-2"
//                             onClick={() => saveEdit(appt.id)}
//                           >
//                             Save
//                           </button>
//                           <button
//                             className="btn btn-secondary btn-sm"
//                             onClick={() => setEditingId(null)}
//                           >
//                             Cancel
//                           </button>
//                         </>
//                       ) : (
//                         <>
//                           <h5 className="card-title">{appt.time}</h5>
//                           <p className="mb-1">
//                             <strong>{appt.name}</strong>
//                           </p>
//                           <p className="mb-1">{appt.haircut}</p>
//                           <p className="mb-2 text-muted">
//                             {appt.phone}
//                           </p>

//                           <button
//                             className="btn btn-warning btn-sm me-2"
//                             onClick={() => startEdit(appt)}
//                           >
//                             Edit
//                           </button>
//                           <button
//                             className="btn btn-danger btn-sm"
//                             onClick={() =>
//                               deleteAppointment(appt.id)
//                             }
//                           >
//                             Delete
//                           </button>

//                           {isNext && (
//                             <div className="mt-2 text-primary fw-bold">
//                               Next Appointment
//                             </div>
//                           )}
//                         </>
//                       )}

//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// }








// import React, { useState, useEffect } from "react";
// import { db, auth } from "../firebase/firebase";
// import {
//   collection,
//   onSnapshot,
//   deleteDoc,
//   doc,
//   updateDoc
// } from "firebase/firestore";
// import { onAuthStateChanged, signOut } from "firebase/auth";
// import { useNavigate } from "react-router-dom";

// export default function About() {
//   const navigate = useNavigate();

//   const [appointments, setAppointments] = useState([]);
//   const [editingId, setEditingId] = useState(null);
//   const [editData, setEditData] = useState({});
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       if (!user || user.email !== "stefanstojilkovicspqr@gmail.com") {
//         navigate("/admin-login");
//       } else {
//         setLoading(false);
//       }
//     });

//     return () => unsubscribe();
//   }, [navigate]);

//   useEffect(() => {
//     if (loading) return;

//     const collectionRef = collection(db, "appointments");
//     const unsubscribe = onSnapshot(collectionRef, (snapshot) => {
//       const data = snapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data()
//       }));
//       setAppointments(data);
//     });

//     return () => unsubscribe();
//   }, [loading]);

//   const deleteAppointment = async (id) => {
//     if (!window.confirm("Delete this appointment?")) return;
//     try {
//       await deleteDoc(doc(db, "appointments", id));
//     } catch (err) {
//       console.error(err);
//       alert("Delete failed");
//     }
//   };

//   const startEdit = (appt) => {
//     setEditingId(appt.id);
//     setEditData({ ...appt });
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setEditData((prev) => ({ ...prev, [name]: value }));
//   };

//   const saveEdit = async (id) => {
//     try {
//       const { name, phone, haircut, date, time } = editData;
//       await updateDoc(doc(db, "appointments", id), {
//         name,
//         phone,
//         haircut,
//         date,
//         time
//       });
//       setEditingId(null);
//     } catch (err) {
//       console.error(err);
//       alert("Update failed");
//     }
//   };

//   const handleLogout = async () => {
//     try {
//       await signOut(auth);
//       navigate("/admin-login");
//     } catch (err) {
//       console.error(err);
//       alert("Logout failed");
//     }
//   };

//   // ✅ SORTIRANO (FIX)
//   const sortedAppointments = [...appointments].sort(
//     (a, b) =>
//       new Date(a.date + "T" + a.time) -
//       new Date(b.date + "T" + b.time)
//   );

//   const groupedAppointments = sortedAppointments.reduce((acc, appt) => {
//     if (!acc[appt.date]) acc[appt.date] = [];
//     acc[appt.date].push(appt);
//     return acc;
//   }, {});

//   // ✅ NEXT APPOINTMENT (FIX)
//   const now = new Date();

//   const nextAppt = sortedAppointments.find(
//     (appt) => new Date(appt.date + "T" + appt.time) > now
//   );

//   if (loading) return <div className="text-center py-5">Loading...</div>;

//   return (
//     <div className="container py-5 admin-dashboard">
//       <div className="d-flex justify-content-between align-items-center mb-4">
//         <h2>Salon Dashboard</h2>
//         <button className="btn btn-danger" onClick={handleLogout}>
//           Logout
//         </button>
//       </div>

//       {Object.keys(groupedAppointments).map((date) => (
//         <div key={date} className="mb-5">
//           <h4 className="mb-3">
//             {new Date(date).toLocaleDateString()}
//           </h4>

//           <div className="row">
//             {groupedAppointments[date].map((appt) => {
//               const isNext = nextAppt && nextAppt.id === appt.id;

//               return (
//                 <div key={appt.id} className="col-md-4 mb-3">
//                   <div
//                     className={`card shadow-sm ${
//                       isNext ? "border-primary" : ""
//                     }`}
//                     style={{ borderWidth: isNext ? "2px" : "1px" }}
//                   >
//                     <div className="card-body">

//                       {editingId === appt.id ? (
//                         <>
//                           {["name", "phone", "haircut", "date", "time"].map(
//                             (field) => (
//                               <input
//                                 key={field}
//                                 name={field}
//                                 type={field === "date" ? "date" : "text"}
//                                 value={editData[field] || ""}
//                                 onChange={handleChange}
//                                 className="form-control mb-2"
//                               />
//                             )
//                           )}

//                           <button
//                             className="btn btn-success btn-sm me-2"
//                             onClick={() => saveEdit(appt.id)}
//                           >
//                             Save
//                           </button>
//                           <button
//                             className="btn btn-secondary btn-sm"
//                             onClick={() => setEditingId(null)}
//                           >
//                             Cancel
//                           </button>
//                         </>
//                       ) : (
//                         <>
//                           <h5 className="card-title">{appt.time}</h5>
//                           <p className="mb-1">
//                             <strong>{appt.name}</strong>
//                           </p>
//                           <p className="mb-1">{appt.haircut}</p>
//                           <p className="mb-2 text-muted">
//                             {appt.phone}
//                           </p>

//                           <button
//                             className="btn btn-warning btn-sm me-2"
//                             onClick={() => startEdit(appt)}
//                           >
//                             Edit
//                           </button>
//                           <button
//                             className="btn btn-danger btn-sm"
//                             onClick={() =>
//                               deleteAppointment(appt.id)
//                             }
//                           >
//                             Delete
//                           </button>

//                           {isNext && (
//                             <div className="mt-2 text-primary fw-bold">
//                               Next Appointment
//                             </div>
//                           )}
//                         </>
//                       )}

//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// }





// import React, { useState, useEffect } from "react";
// import { db, auth } from "../firebase/firebase";
// import {
//   collection,
//   onSnapshot,
//   deleteDoc,
//   doc,
//   updateDoc
// } from "firebase/firestore";
// import { onAuthStateChanged, signOut } from "firebase/auth";
// import { useNavigate } from "react-router-dom";

// export default function About() {
//   const navigate = useNavigate();

//   const [appointments, setAppointments] = useState([]);
//   const [editingId, setEditingId] = useState(null);
//   const [editData, setEditData] = useState({});
//   const [loading, setLoading] = useState(true);

//   // format vremena
//   const formatTime = (time) => {
//     if (!time) return "00:00";
//     const [h, m] = time.split(":");
//     return `${h.padStart(2, "0")}:${(m || "00").padStart(2, "0")}`;
//   };

//   const getDateTime = (date, time) => {
//     const [y, m, d] = date.split("-");
//     const [h, min] = formatTime(time).split(":");
//     return new Date(y, m - 1, d, h, min, 0);
//   };

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       if (!user || user.email !== "stefanstojilkovicspqr@gmail.com") {
//         navigate("/admin-login");
//       } else {
//         setLoading(false);
//       }
//     });

//     return () => unsubscribe();
//   }, [navigate]);

//   useEffect(() => {
//     if (loading) return;

//     const collectionRef = collection(db, "appointments");
//     const unsubscribe = onSnapshot(collectionRef, (snapshot) => {
//       const data = snapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data()
//       }));
//       setAppointments(data);
//     });

//     return () => unsubscribe();
//   }, [loading]);

//   const deleteAppointment = async (id) => {
//     if (!window.confirm("Delete this appointment?")) return;
//     try {
//       await deleteDoc(doc(db, "appointments", id));
//     } catch (err) {
//       console.error(err);
//       alert("Delete failed");
//     }
//   };

//   const startEdit = (appt) => {
//     setEditingId(appt.id);
//     setEditData({ ...appt });
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setEditData((prev) => ({ ...prev, [name]: value }));
//   };

//   const saveEdit = async (id) => {
//     try {
//       const { name, phone, haircut, date, time } = editData;
//       await updateDoc(doc(db, "appointments", id), {
//         name,
//         phone,
//         haircut,
//         date,
//         time: formatTime(time)
//       });
//       setEditingId(null);
//     } catch (err) {
//       console.error(err);
//       alert("Update failed");
//     }
//   };

//   const handleLogout = async () => {
//     try {
//       await signOut(auth);
//       navigate("/admin-login");
//     } catch (err) {
//       console.error(err);
//       alert("Logout failed");
//     }
//   };

//   // SORTIRANO
//   const sortedAppointments = [...appointments].sort(
//     (a, b) => getDateTime(a.date, a.time) - getDateTime(b.date, b.time)
//   );

//   // GRUPISANO
//   const groupedAppointments = sortedAppointments.reduce((acc, appt) => {
//     if (!acc[appt.date]) acc[appt.date] = [];
//     acc[appt.date].push(appt);
//     return acc;
//   }, {});

//   // 🔥 NAJNOVIJI TERMIN PO DATUMU (POSLEDNJI)
//   const latestByDate = {};

//   Object.keys(groupedAppointments).forEach((date) => {
//     const list = groupedAppointments[date];
//     if (list.length > 0) {
//       latestByDate[date] = list[list.length - 1].id; // 👉 POSLEDNJI
//     }
//   });

//   if (loading) return <div className="text-center py-5">Loading...</div>;

//   return (
//     <div className="container py-5 admin-dashboard">
//       <div className="d-flex justify-content-between align-items-center mb-4">
//         <h2>Salon Dashboard</h2>
//         <button className="btn btn-danger" onClick={handleLogout}>
//           Logout
//         </button>
//       </div>

//       {Object.keys(groupedAppointments).map((date) => (
//         <div key={date} className="mb-5">
//           <h4 className="mb-3">
//             {new Date(date).toLocaleDateString()}
//           </h4>

//           <div className="row">
//             {groupedAppointments[date].map((appt) => {
//               const isNext = latestByDate[date] === appt.id;

//               return (
//                 <div key={appt.id} className="col-md-4 mb-3">
//                   <div
//                     className={`card shadow-sm ${
//                       isNext ? "border-primary" : ""
//                     }`}
//                     style={{ borderWidth: isNext ? "2px" : "1px" }}
//                   >
//                     <div className="card-body">

//                       {editingId === appt.id ? (
//                         <>
//                           {["name", "phone", "haircut", "date", "time"].map(
//                             (field) => (
//                               <input
//                                 key={field}
//                                 name={field}
//                                 type={
//                                   field === "date"
//                                     ? "date"
//                                     : field === "time"
//                                     ? "time"
//                                     : "text"
//                                 }
//                                 value={editData[field] || ""}
//                                 onChange={handleChange}
//                                 className="form-control mb-2"
//                               />
//                             )
//                           )}

//                           <button
//                             className="btn btn-success btn-sm me-2"
//                             onClick={() => saveEdit(appt.id)}
//                           >
//                             Save
//                           </button>
//                           <button
//                             className="btn btn-secondary btn-sm"
//                             onClick={() => setEditingId(null)}
//                           >
//                             Cancel
//                           </button>
//                         </>
//                       ) : (
//                         <>
//                           <h5 className="card-title">
//                             {formatTime(appt.time)}
//                           </h5>
//                           <p className="mb-1">
//                             <strong>{appt.name}</strong>
//                           </p>
//                           <p className="mb-1">{appt.haircut}</p>
//                           <p className="mb-2 text-muted">
//                             {appt.phone}
//                           </p>

//                           <button
//                             className="btn btn-warning btn-sm me-2"
//                             onClick={() => startEdit(appt)}
//                           >
//                             Edit
//                           </button>
//                           <button
//                             className="btn btn-danger btn-sm"
//                             onClick={() =>
//                               deleteAppointment(appt.id)
//                             }
//                           >
//                             Delete
//                           </button>

//                           {isNext && (
//                             <div className="mt-2 text-primary fw-bold">
//                               Najnoviji termin
//                             </div>
//                           )}
//                         </>
//                       )}

//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// }















// import React, { useState, useEffect } from "react";
// import { db, auth } from "../firebase/firebase";
// import {
//   collection,
//   onSnapshot,
//   deleteDoc,
//   doc,
//   updateDoc
// } from "firebase/firestore";
// import { onAuthStateChanged, signOut } from "firebase/auth";
// import { useNavigate } from "react-router-dom";

// export default function About() {
//   const navigate = useNavigate();

//   const [appointments, setAppointments] = useState([]);
//   const [editingId, setEditingId] = useState(null);
//   const [editData, setEditData] = useState({});
//   const [loading, setLoading] = useState(true);

//   // format vremena
//   const formatTime = (time) => {
//     if (!time) return "00:00";
//     const [h, m] = time.split(":");
//     return `${h.padStart(2, "0")}:${(m || "00").padStart(2, "0")}`;
//   };

//   const getDateTime = (date, time) => {
//     const [y, m, d] = date.split("-");
//     const [h, min] = formatTime(time).split(":");
//     return new Date(y, m - 1, d, h, min, 0);
//   };

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       if (!user || user.email !== "stefanstojilkovicspqr@gmail.com") {
//         navigate("/admin-login");
//       } else {
//         setLoading(false);
//       }
//     });

//     return () => unsubscribe();
//   }, [navigate]);

//   useEffect(() => {
//     if (loading) return;

//     const collectionRef = collection(db, "appointments");
//     const unsubscribe = onSnapshot(collectionRef, (snapshot) => {
//       const data = snapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data()
//       }));
//       setAppointments(data);
//     });

//     return () => unsubscribe();
//   }, [loading]);

//   const deleteAppointment = async (id) => {
//     if (!window.confirm("Delete this appointment?")) return;
//     try {
//       await deleteDoc(doc(db, "appointments", id));
//     } catch (err) {
//       console.error(err);
//       alert("Delete failed");
//     }
//   };

//   const startEdit = (appt) => {
//     setEditingId(appt.id);
//     setEditData({ ...appt });
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setEditData((prev) => ({ ...prev, [name]: value }));
//   };

//   const saveEdit = async (id) => {
//     try {
//       const { name, phone, haircut, date, time } = editData;
//       await updateDoc(doc(db, "appointments", id), {
//         name,
//         phone,
//         haircut,
//         date,
//         time: formatTime(time)
//       });
//       setEditingId(null);
//     } catch (err) {
//       console.error(err);
//       alert("Update failed");
//     }
//   };

//   const handleLogout = async () => {
//     try {
//       await signOut(auth);
//       navigate("/admin-login");
//     } catch (err) {
//       console.error(err);
//       alert("Logout failed");
//     }
//   };

//   // SORTIRANO
//   const sortedAppointments = [...appointments].sort(
//     (a, b) => getDateTime(a.date, a.time) - getDateTime(b.date, b.time)
//   );

//   // GRUPISANO
//   const groupedAppointments = sortedAppointments.reduce((acc, appt) => {
//     if (!acc[appt.date]) acc[appt.date] = [];
//     acc[appt.date].push(appt);
//     return acc;
//   }, {});

//   // 🔥 NAJNOVIJI TERMIN GLOBALNO (SAMO JEDAN)
//   const latestAppt =
//     sortedAppointments.length > 0
//       ? sortedAppointments[sortedAppointments.length - 1]
//       : null;

//   if (loading) return <div className="text-center py-5">Loading...</div>;

//   return (
//     <div className="container py-5 admin-dashboard">
//       <div className="d-flex justify-content-between align-items-center mb-4">
//         <h2>Salon Dashboard</h2>
//         <button className="btn btn-danger" onClick={handleLogout}>
//           Logout
//         </button>
//       </div>

//       {Object.keys(groupedAppointments).map((date) => (
//         <div key={date} className="mb-5">
//           <h4 className="mb-3">
//             {new Date(date).toLocaleDateString()}
//           </h4>

//           <div className="row">
//             {groupedAppointments[date].map((appt) => {
//               const isNext = latestAppt && latestAppt.id === appt.id;

//               return (
//                 <div key={appt.id} className="col-md-4 mb-3">
//                   <div
//                     className={`card shadow-sm ${
//                       isNext ? "border-primary" : ""
//                     }`}
//                     style={{ borderWidth: isNext ? "2px" : "1px" }}
//                   >
//                     <div className="card-body">

//                       {editingId === appt.id ? (
//                         <>
//                           {["name", "phone", "haircut", "date", "time"].map(
//                             (field) => (
//                               <input
//                                 key={field}
//                                 name={field}
//                                 type={
//                                   field === "date"
//                                     ? "date"
//                                     : field === "time"
//                                     ? "time"
//                                     : "text"
//                                 }
//                                 value={editData[field] || ""}
//                                 onChange={handleChange}
//                                 className="form-control mb-2"
//                               />
//                             )
//                           )}

//                           <button
//                             className="btn btn-success btn-sm me-2"
//                             onClick={() => saveEdit(appt.id)}
//                           >
//                             Save
//                           </button>
//                           <button
//                             className="btn btn-secondary btn-sm"
//                             onClick={() => setEditingId(null)}
//                           >
//                             Cancel
//                           </button>
//                         </>
//                       ) : (
//                         <>
//                           <h5 className="card-title">
//                             {formatTime(appt.time)}
//                           </h5>
//                           <p className="mb-1">
//                             <strong>{appt.name}</strong>
//                           </p>
//                           <p className="mb-1">{appt.haircut}</p>
//                           <p className="mb-2 text-muted">
//                             {appt.phone}
//                           </p>

//                           <button
//                             className="btn btn-warning btn-sm me-2"
//                             onClick={() => startEdit(appt)}
//                           >
//                             Edit
//                           </button>
//                           <button
//                             className="btn btn-danger btn-sm"
//                             onClick={() => deleteAppointment(appt.id)}
//                           >
//                             Delete
//                           </button>

//                           {isNext && (
//                             <div className="mt-2 text-primary fw-bold">
//                               Najnoviji termin
//                             </div>
//                           )}
//                         </>
//                       )}

//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// }















import React, { useState, useEffect } from "react";
import { db, auth } from "../firebase/firebase";
import {
  collection,
  onSnapshot,
  deleteDoc,
  doc,
  updateDoc
} from "firebase/firestore";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";

export default function Dashboard() {
  const navigate = useNavigate();

  const [appointments, setAppointments] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editData, setEditData] = useState({});
  const [loading, setLoading] = useState(true);

  const formatTime = (time) => {
    if (!time) return "00:00";
    const [h, m] = time.split(":");
    return `${h.padStart(2, "0")}:${(m || "00").padStart(2, "0")}`;
  };

  const getDateTime = (date, time) => {
    if (!date) return new Date(0);
    const [y, m, d] = date.split("-");
    const [h, min] = formatTime(time).split(":");
    return new Date(y, m - 1, d, h, min, 0);
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (!user || user.email !== "stefanstojilkovicspqr@gmail.com") {
        navigate("/admin-login");
      } else {
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  useEffect(() => {
    if (loading) return;

    const collectionRef = collection(db, "appointments");
    const unsubscribe = onSnapshot(collectionRef, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));
      setAppointments(data);
    });

    return () => unsubscribe();
  }, [loading]);

  const deleteAppointment = async (id) => {
    if (!window.confirm("Delete this appointment?")) return;
    try {
      await deleteDoc(doc(db, "appointments", id));
    } catch (err) {
      console.error(err);
      alert("Delete failed");
    }
  };

  const startEdit = (appt) => {
    setEditingId(appt.id);
    setEditData({ ...appt });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditData((prev) => ({ ...prev, [name]: value }));
  };

  const saveEdit = async (id) => {
    try {
      const { name, phone, haircut, date, time } = editData;
      await updateDoc(doc(db, "appointments", id), {
        name,
        phone,
        haircut,
        date,
        time: formatTime(time)
      });
      setEditingId(null);
    } catch (err) {
      console.error(err);
      alert("Update failed");
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/admin-login");
    } catch (err) {
      console.error(err);
      alert("Logout failed");
    }
  };

  const sortedAppointments = [...appointments]
    .filter(a => a.date)
    .sort((a, b) => getDateTime(a.date, a.time) - getDateTime(b.date, b.time));

  const groupedAppointments = sortedAppointments.reduce((acc, appt) => {
    if (!acc[appt.date]) acc[appt.date] = [];
    acc[appt.date].push(appt);
    return acc;
  }, {});

  const latestAppt =
    sortedAppointments.length > 0
      ? sortedAppointments[sortedAppointments.length - 1]
      : null;

  if (loading) return <div className="text-center py-5">Loading...</div>;

  return (
    <div className="container py-5 admin-dashboard">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Salon Dashboard</h2>
        <button className="btn btn-danger" onClick={handleLogout}>
          Logout
        </button>
      </div>

      {Object.keys(groupedAppointments).map((date) => (
        <div key={date} className="mb-5">
          <h4 className="mb-3">
            {new Date(date).toLocaleDateString()}
          </h4>

          <div className="row">
            {groupedAppointments[date].map((appt) => {
              const isNext = latestAppt && latestAppt.id === appt.id;

              return (
                <div key={appt.id} className="col-md-4 mb-3">
                  <div
                    className={`card shadow-sm ${isNext ? "border-primary" : ""}`}
                    style={{ borderWidth: isNext ? "2px" : "1px" }}
                  >
                    <div className="card-body">

                      {editingId === appt.id ? (
                        <>
                          {["name", "phone", "haircut", "date", "time"].map((field) => (
                            <input
                              key={field}
                              name={field}
                              type={
                                field === "date"
                                  ? "date"
                                  : field === "time"
                                  ? "time"
                                  : "text"
                              }
                              value={editData[field] || ""}
                              onChange={handleChange}
                              className="form-control mb-2"
                            />
                          ))}

                          <button
                            className="btn btn-success btn-sm me-2"
                            onClick={() => saveEdit(appt.id)}
                          >
                            Save
                          </button>
                          <button
                            className="btn btn-secondary btn-sm"
                            onClick={() => setEditingId(null)}
                          >
                            Cancel
                          </button>
                        </>
                      ) : (
                        <>
                          <h5 className="card-title">
                            {formatTime(appt.time)}
                          </h5>
                          <p className="mb-1">
                            <strong>{appt.name}</strong>
                          </p>
                          <p className="mb-1">{appt.haircut}</p>
                          <p className="mb-2 text-muted">{appt.phone}</p>

                          <button
                            className="btn btn-warning btn-sm me-2"
                            onClick={() => startEdit(appt)}
                          >
                            Edit
                          </button>
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => deleteAppointment(appt.id)}
                          >
                            Delete
                          </button>

                          {isNext && (
                            <div className="mt-2 text-primary fw-bold">
                              Latest booking
                            </div>
                          )}
                        </>
                      )}

                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}